import React, { useContext, useState } from "react";
import PsContext from "../../context";
import Header from "../header";
import NotificationList from "./notificationList";

const Notification = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);

  return (
    <>
      <Header backAction={true} title="Notification" />

      <div className="">
        <div className="container ">
          <section className=" pt-0 pb-0">
            <NotificationList titleText={"Notification"} />
          </section>
          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default Notification;
